<template>
  <div class="l-row">
    <form-group :label="$t('category.label')">
      <input class="form-select" v-model="item.from.category" :columns="3" readonly="readonly">
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="$t('category.label')" :columns="3">
      <input v-model="itemsNames.label" class="form-select" readonly="readonly">
    </form-group>

    <div class="l-col-2@md vertical-center">
      <slot/>
    </div>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'

  export default {
    data: () => ({
      itemsNames: [],
      doneFilling: false,
      loaderItemsNames: true
    }),
    props: {
      preset: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getCategories('marketplace', 'leroy', this.item.to.department)
        .then(category => {
          this.itemsNames = category.find(category => this.item.to.category === category.code)
          this.loaderItemsNames = false
          this.doneFilling = !this.loaderItemsNames
          this.$emit('loading', this.loaderItemsNames)
        })
    },
    components: {
      Panel,
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// CategorizationItem.vue?7dfe0b44